<header>
    <img src="assets/imgs/logo-evento.png" alt="Logo evento">
    <h1><span i18n="@@web-inscripciones.inscripciones">Inscripciones {{event_name}} {{event_year}}</span></h1>
    <img src="assets/imgs/logo-collegi.png" alt="El Col·legi">
</header>
<section class="page-body">
    <div class="msg msg-error">
        <mat-icon>report_problem</mat-icon>
        <div class="texto">
            <h4 class="error-head">
                <span><span i18n="@@web-inscripciones.error-realizando-el-pago">Error realizando el pago</span></span>
            </h4>
            <p><span i18n="@@web-inscripciones.no-se-ha-podido-terminar-su-inscripcion">No se ha podido terminar su inscripción</span>
                <strong><span i18n="@@web-inscripciones.el-pago-no-ha-acabado-correctamente">el pago no ha acabado correctamente</span></strong>.
            </p>
            <p><span i18n="@@web-inscripciones.por-favor-intentelo-mas-tarde">Por favor, inténtelo más tarde</span></p>
        </div>
    </div>
</section>
<footer>
    <nav class="btns-nav">
        <button mat-raised-button color="primary" routerLink="/inscript">
            <span i18n="@@web-inscripciones.realizar-otra-inscripcion">Realizar otra inscripción</span>
        </button>
    </nav>
</footer>
